import { Controller, useForm } from "react-hook-form";
import { GetBeneficiaries, sendOtp } from "../../services/beneficiaries";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import { api, handleToast } from "../../services/config";
import { ToastContainer } from "react-toastify";
import { contextApi } from "../../context/contextApi";
import { useContext } from "react";

export const RegistrationFormRecive = ({ title }) => {
  const formatFullName = (name, lastName) => {
    if (!name && !lastName) return "نامشخص";
    if (name === lastName) return lastName || name;
    return `${name || ""} ${lastName || ""}`.trim();
  };

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    setValue,
  } = useForm();
  const [timer, setTimer] = useState(0);
  const [load, setLoad] = useState(false);
  const [shebaValue, setShebaValue] = useState(null);
  const [pepole, setPepole] = useState([]);
  const [userId, setUserId] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectItem, setSelectItem] = useState();
  const context = useContext(contextApi);
  const { state } = useLocation();
  const [isDark, setIsDark] = useState(
    () =>
      typeof window !== "undefined" && document.body.classList.contains("dark"),
  );

  useEffect(() => {
    const checkDark = () => setIsDark(document.body.classList.contains("dark"));
    checkDark();
    const observer = new MutationObserver(() => {
      checkDark();
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const GetBeneficiaryList = async () => {
      try {
        setPepole([]);
        let res = await GetBeneficiaries();

        setPepole(res);
      } catch (error) {
        console.log(error);
      }
    };

    GetBeneficiaryList();
  }, []);

  useEffect(() => {
    const storedStartTime = localStorage.getItem("startTime");
    // if (!storedStartTime) {
    //   const startTime = Math.floor(Date.now() / 1000);
    //   localStorage.setItem("startTime", startTime.toString());
    // }
    const currentTime = Math.floor(Date.now() / 1000);
    const elapsedTime = currentTime - parseInt(storedStartTime, 10);
    if (elapsedTime < 120) {
      setTimer(120 - elapsedTime);
    }
  }, []);

  const data = [
    { id: 1, dataId: 1, title: "کیف پول ریالی  pos " },
    { id: 2, dataId: 2, title: "کیف پول درگاه اینترنتی" },
    { id: 3, dataId: 3, title: " کیف پول ریالی حساب" },
    { id: 4, dataId: 4, title: "کیف پول ریالی  چک" },
    { id: 5, dataId: 5, title: " کیف پول ریالی vip  " },
    { id: 6, dataId: 6, title: "کیف پول ریالی کارت اعتباری" },
    { id: 7, dataId: 7, title: "Tether" },
    { id: 8, dataId: 8, title: "BTC" },
    { id: 9, dataId: 9, title: "ETH" },
    { id: 10, dataId: 10, title: "آب شده" },
    { id: 11, dataId: 11, title: "سکه امامی" },
    { id: 12, dataId: 12, title: "سکه بهار آزادی" },
    { id: 13, dataId: 13, title: "دلار" },
    { id: 14, dataId: 14, title: "یورو" },
    { id: 15, dataId: 15, title: "درهم" },
  ];

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const handlSendOTP = async () => {
    const beneficiary = watch("one");
    const sheba = watch("four");
    const walletType = watch("two");
    const walletName = watch("three");
    const amount = watch("five");

    // چک کردن اینکه همه فیلدها پر شده باشند
    const missingFields = [];

    if (!beneficiary) {
      missingFields.push("ذینفان");
    }
    if (!sheba || sheba.trim() === "") {
      missingFields.push("شماره شبا");
    }
    if (!walletType) {
      missingFields.push("نوع کیف");
    }
    if (!walletName) {
      missingFields.push("نام کیف پول");
    }
    if (!amount || amount === "" || amount === "0") {
      missingFields.push("مبلغ");
    }

    if (missingFields.length > 0) {
      handleToast("error", `لطفا ${missingFields.join("، ")} را وارد کنید`);
      return;
    }

    const startTime = Math.floor(Date.now() / 1000);
    localStorage.setItem("startTime", startTime.toString());
    setTimer(120);
    const bodyOtp = {
      mobile: localStorage.mobile, // در صورتی که کاربر وارد نشده بود
    };
    try {
      setLoad(true);
      await sendOtp(bodyOtp);
      handleToast("success", "کد ارسال شده را وارد کنید");
    } catch (error) {
      setTimer(0);
      localStorage.removeItem("startTime");
      handleToast("error", "خطا در ارسال کد تایید");
    }
    setTimeout(() => {
      setLoad(false);
    }, 500);
  };

  function handleChange(val) {
    setSelectItem(data.filter((e) => e.id == val));
  }
  const navigate = useNavigate();
  useEffect(() => {
    if (!state) {
      navigate("/");
      return;
    }
    handleChange(searchParams.get("id"));
  }, []);
  const dataForm = [
    {
      title: "ذینفان",
      registerOption: "one",
      options: {
        required: { value: true, message: "این فیلد اجباری می باشد" },
      },
      type: "select",
      inputType: "text",
    },
    {
      title: "شماره شبا",
      registerOption: "four",
      options: {
        required: { value: true, message: "این فیلد اجباری می باشد" },
      },
      type: "input",
      placeholder: "IR",
      inputType: "text",
    },
    {
      title: "نوع کیف",
      registerOption: "two",
      options: { required: true },
      messageError: "لطفا یک گزینه را انتخاب کنید",
      type: "select",
      select: [
        { id: 1, title: "ریالی" },
        { id: 2, title: "تتر" },
        { id: 3, title: "رمز ارز" },
        { id: 4, title: "طلا" },
      ],
      inputType: "text",
    },
    {
      title: "نام کیف پول",
      registerOption: "three",
      options: {
        required: { value: true, message: "این فیلد اجباری می باشد" },
      },
      type: "select",
      placeholder: "",
      select: selectItem,
      inputType: "number",
    },
    {
      title: "مبلغ(ریال)",
      registerOption: "five",
      options: {
        required: { value: true, message: "این فیلد اجباری می باشد" },
      },
      type: "input",
      inputType: "number",
    },

    {
      title: "کدتایید",
      registerOption: "six",
      options: {
        required: { value: true, message: "این فیلد اجباری می باشد" },
      },
      type: "input",
      inputType: "number",
      btn: true,
    },
  ];

  const getSheba = (items) => {
    setShebaValue(items.sheba);
    setUserId(items.id);
    setValue("four", items.sheba);
    setValue("three", searchParams.get("itemId"));
  };

  const onSubmit = async (data) => {
    const amount = +data.five.replace(/,/g, "");
    const mojodi = state ? parseInt(state) : null;

    if (amount > mojodi) {
      handleToast("error", "مبلغ از موجودی حساب شما بیشتر است");
      return;
    }
    const formData = {
      otp: +data.six,
      asset_id: +data.three,
      amount: amount,
      des: "توضیحات",
      withdraw_type: "bank", // active_assets, beneficiaries
      beneficiary_id: userId,
    };

    try {
      const response = await api.post("transactions/add-withdraw", formData, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: `Bearer ${localStorage.getItem("login")}`,
        },
      });
      handleToast("success", "درخواست برداشت ثبت گردید");
      setTimeout(() => {
        navigate("/");
      }, 3000);
    } catch (error) {
      console.log(error);
      handleToast("error", error.response.data.message);
    }
  };

  const handleClick = (buttonName) => {
    context.recordClick(buttonName);
  };

  return (
    <div
      className={`form rounded-2xl shadow p-3 max-w-full md:w-3/4 lg:w-2/4 mx-10 md:mx-auto md:p-3 lg:p-6 ${
        isDark ? "card" : "card2"
      }`}
    >
      <ToastContainer />

      <span className=" text-[#0010c6] dark:text-white">حساب بانکی جدید</span>
      <form onSubmit={handleSubmit(onSubmit)} className="mt-3">
        {dataForm.map((item, index) => {
          return (
            <div key={index}>
              <label htmlFor="" className="text-xs text-[#0010c6] dark:text-white m-0">
                {item.title}
              </label>
              {item.type == "select" ? (
                <>
                  {item.registerOption === "one" ? (
                    <select
                      name={item.registerOption}
                      {...register(item.registerOption, item.options)}
                      className={`w-full border rounded-md px-2 py-1 text-xs text-black bg-gray-100 dark:bg-gray-400 dark:text-black font-normal outline-none ${
                        (errors[item.registerOption] &&
                          "bg-red-100 border border-red-400") ||
                        ""
                      }`}
                      id=""
                      onChange={(e) => getSheba(JSON.parse(e.target.value))}
                    >
                      <option value="" hidden>
                        انتخاب کنید
                      </option>

                      {pepole.map((items, index) => {
                        return (
                          <option
                            value={JSON.stringify({
                              sheba: items.sheba,
                              id: items.id,
                            })}
                            key={index}
                          >
                             <span>{formatFullName(items?.name, items?.lastname)}</span>
                             -
                              <span>{items?.sheba}</span>
                              -
                              <span>{items?.bank_label}</span>
                          </option>
                        );
                      })}
                    </select>
                  ) : (
                    <select
                      name={item.registerOption}
                      {...register(item.registerOption, item.options)}
                      className={`w-full border rounded-md px-2 py-1 text-xs text-black bg-gray-100 dark:bg-gray-400 dark:text-black font-normal outline-none ${
                        (errors[item.registerOption] &&
                          "bg-red-100 border border-red-400") ||
                        ""
                      }`}
                      id=""
                    >
                      <option value="" hidden>
                        انتخاب کنید
                      </option>

                      {item.select?.map((items) => {
                        return (
                          <option
                            value={items.id}
                            selected={
                              item.registerOption == "three"
                                ? items.dataId == searchParams.get("itemId")
                                  ? "selected"
                                  : ""
                                : items.id == searchParams.get("id")
                                ? "selected"
                                : ""
                            }
                          >
                            {items.title}
                          </option>
                        );
                      })}
                    </select>
                  )}

                  {errors[item.registerOption] && (
                    <p className="text-red-400 text-xs">
                      {errors[item.registerOption].message}
                    </p>
                  )}
                </>
              ) : (
                <div className="relative">
                  {item.registerOption == "five" ? (
                    <Controller
                      control={control}
                      name="five"
                      {...register("five", { required: true })}
                      placeholder={"۰ ریال"}
                      render={({ field: { onChange, name, value } }) => (
                        <NumericFormat
                          className={`w-full border rounded-md px-2 py-1 text-xs text-black bg-gray-100 dark:bg-gray-400 dark:text-black placeholder:text-left font-normal outline-none ${
                            (errors["money"] &&
                              "bg-red-100 border border-red-400") ||
                            ""
                          }`}
                          thousandSeparator=","
                          name={name}
                          value={value}
                          onChange={onChange}
                        />
                      )}
                    />
                  ) : (
                    <input
                      {...register(item.registerOption, item.options)}
                      placeholder={item.placeholder || ""}
                      type={item.inputType}
                      className={` ${
                        item.btn ? " w-2/4 md:w-4/5" : "w-full"
                      } border rounded-md px-2 py-1 text-xs text-black bg-gray-100 dark:bg-gray-400 dark:text-black placeholder:text-left font-normal outline-none ${
                        (errors[item.registerOption] &&
                          "bg-red-100 border border-red-400") ||
                        ""
                      }`}
                      defaultValue={
                        item.registerOption === "four" ? shebaValue : ""
                      }
                      disabled={item.registerOption === "four"}
                    />
                  )}
                  {item.btn && (
                    <button
                      onClick={handlSendOTP}
                      type="button"
                      disabled={timer > 0}
                      className={`text-center bg-blue-500 w-5/12 md:w-1/6 float-left py-1 mr-auto text-white rounded text-sm ${
                        timer > 0
                          ? "opacity-50 bg-gray-500 text-[10px] cursor-not-allowed"
                          : ""
                      }`}
                    >
                      ارسال کد تایید
                      {timer > 0 && ` (${timer}s)`}
                    </button>
                  )}
                  {errors[item.registerOption] && (
                    <p className="text-red-400 text-xs">
                      {errors[item.registerOption].message}
                    </p>
                  )}
                </div>
              )}
            </div>
          );
        })}
        <input
          type="submit"
          onClick={() => handleClick(`کلیک شد برداشت در حساب بانکی ${title}`)}
          value={"برداشت"}
          className="btn-add text-center mt-3 shadow bg-green-600 hover:bg-green-700 w-full rounded text-white p-1 text-sm cursor-pointer"
        />
      </form>
    </div>
  );
};
